<template>
  <section
    v-if="visible"
    class="modal modal-result jump-dialog"
    @click="visible = false"
  >
    <div class="confirm-box" @click.stop>
      <p>{{jumpTitle}}</p>
      <div class="btn-normal" @click="onJump">前往芒果TV</div>
    </div>
  </section>
</template>


<script>
import DialogMixins from '@/mixins/DialogMixins';
import Env from '@/utils/env';
import { wakeupApp } from "@/utils/common";

export default {
  mixins: [DialogMixins],
  props: {
    jumpTitle: {
      type: String,
      default: '需要在芒果TVapp内才能参与！'
    }
  },
  data() {
    return {
      
    };
  },
  methods: {
    onJump() {
      setTimeout(() => {
        this.visible = false;
        let scheme = `imgotv://webview?url=${encodeURIComponent(
          window.location.href
        )}`;
        let url = `https://a.app.qq.com/o/simple.jsp?pkgname=com.hunantv.imgo.activity&ios_scheme=${encodeURIComponent(
          scheme
        )}&android_schema=${encodeURIComponent(scheme)}`;
        if (Env.isIOS) {
          url = `https://msite.api.mgtv.com/download.html?type=2&content=${encodeURIComponent(
            scheme
          )}`;
          scheme = url;
        }
        wakeupApp(url, scheme);
      }, 500);
    }
  },
}
</script>
<style lang="scss">
@import "~@/assets/mixins.scss";

.jump-dialog{
  .confirm-box {
    background-image: url("~@/assets/img/confirm.png");
    @include px2vw(width, 610);
    @include px2vw(height, 315);
    @include px2vw(font-size, 34);
    @include px2vw(padding-top, 55);
    text-align: center;
    p {
      font-weight: 500;
    }
    .btn-normal {
      @include px2vw(margin-top, 57);
    }
  }
}

</style>